import { getApiUrl } from '@v4/config';
import { extractMarketingParamsFromLocalStorage } from '@v4//marketing-params';
import { stringify } from 'query-string';
import { isEmpty } from 'lodash';

export const baseUrl = `${getApiUrl()}/dkwp/v3/click-to-call/click-event`;

// Monitoring marketing params
const buildRequestUrl = () => {
    const marketingParamsFromLocalStorage = extractMarketingParamsFromLocalStorage();

    return isEmpty(marketingParamsFromLocalStorage)
        ? baseUrl
        : `${baseUrl}?${stringify({ ...marketingParamsFromLocalStorage })}`;
};

// Events for the affiliation tracker
export const CLICK_TO_CALL_EVENTS = {
    default: 'CLICK_TO_CALL',
    trigger: 'CLICK_TO_CALL_TRIGGER',
};

// Event sources for the affiliation tracker
export const CLICK_TO_CALL_EVENT_SOURCES = {
    popup: 'POPUP',
    cta: 'CTA',
    snackbar: 'SNACKBAR',
    ctaPopup: 'CTA - POPUP',
    snackbarPopup: 'SNACKBAR - POPUP',
};

// Send the data about click on click-to-call buttons
export const sendClickToCallData = (requestBody) =>
    new Promise((resolve, reject) => {
        const url = buildRequestUrl();

        fetch(url, {
            body: JSON.stringify(requestBody),
            method: 'POST',
        }).catch((error) => reject(error));
    });
